import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Link, graphql, useStaticQuery } from 'gatsby'
import styled, { css } from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import ReactModal from 'styled-react-modal'
import { colors, device } from '../../styles/config'
import CloseSvg from '../../images/close.svg'
import Form from './Form'
import useCalendarLimit from '../../hooks/useCalendarLimit'

const Container = styled.div`
  ${ props => props.theme.wrapper }
  margin: initial;
  max-width: initial;
  background: white;
  padding: 5rem;
  overflow: hidden;
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media ${ device.sm } {
    padding: 1rem;
  }

  @media ${ device.lg } {
    padding: 3.5rem;
  }

  @media ${ device.md } {
    padding: 1.5rem;
  }
`

const CloseButton = styled.div`
  width: 50px;
  height: 50px;
  position: fixed;
  right: 2.875rem;
  top: 2.875rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  transform: translate3d(0,0,0);
  z-index: 1;

  > svg {
    width: 30px;
    height: 30px;

    path {
      transition: fill 0.3s;
    }
  }

  @media ${ device.hover } {
    &:hover {
      svg {
        path {
          fill: ${ colors.primary };
        }
      }
    }
  }

  @media ${ device.sm } {
    right: 1rem;
    top: 1rem;
  }
`

const FormContainer = ({ modalOpen, closeModal }) => {
  const calendarLimit = useCalendarLimit()

  return (
    <ReactModal
      isOpen={modalOpen}
      onBackgroundClick={closeModal}
      onEscapeKeydown={closeModal}
      allowScroll={true}
    // opacity={opacity}
    // afterOpen={afterOpen}
    // beforeClose={beforeClose}
    // backgroundProps={{ opacity }}
    >
      <CloseButton onClick={closeModal}>
        <CloseSvg/>
      </CloseButton>
      <Container>
        <Form calendarLimit={calendarLimit}/>
      </Container>
    </ReactModal>
  )
}

export default FormContainer
